export const ConfigMantenedorCesionario = {
   barraBusqueda: {
      criterios: ["Razon Social", "Rut", "Dirección"],
      criteriosKeys: ["razonSocial", "rut", "direccion"],
      criterioPrincipal: "Razon Social",
   },
   table: {
      title: "Mantenedor Cesionario",
      add: "Carga Documento",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
